export var clamp=function(a,t,n){return Math.min(n,Math.max(t,a))};